<template>
  <div>
    <v-card flat color="transparent" class="mt-7">
      <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
        <v-toolbar-title>{{$t('animal.todayFeedInfo')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          outlined
          small
          class="mr-2"
          :to="{
            name: 'AnimalFeedInfoEdit',
            params: { animal_number: $route.params.animal_number },
          }"
        >
          <!-- <v-icon>mdi-pencil</v-icon> -->
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card flat color="transparent" class="mt-7">
      <v-row>
        <v-col cols="4">
          <v-card class="pa-2 elevation-0" height="100" color="green2">
            <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
            <!-- <v-list color="green2"> -->
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ $t("animal.feedsName") }}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("animal.feedsName") }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2 text-no-wrap">
                    <div class="text-subtitle-2">
                      <!-- Green fodder, hay, legumes, non-legumes, silage, TMR,
                      concentrates, etc. -->
                      {{ (feedLatestData && feedLatestData.feedName != '') ? feedLatestData.feedName : $t('notSpecified') }}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            <!-- </v-list> -->
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="pa-2 elevation-0" height="100" color="green2">
            <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
            <!-- <v-list color="pa-2 green2"> -->
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ $t("animal.firstFeedQuantity") }}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("animal.firstFeedQuantity") }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2 text-no-wrap">
                    <div class="text-subtitle-2">
                      <!-- 12.5 -->
                      {{ (feedLatestData && feedLatestData.feedQty ) ? feedLatestData.feedQty : $t('notSpecified') }}
                      <span>
                        <!-- Kg -->
                        {{ feedLatestData ? feedLatestData.feedUom : "" }}
                      </span>
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            <!-- </v-list> -->
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="pa-2 elevation-0" height="100" color="green2">
            <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
            <!-- <v-list color="green2"> -->
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ $t("notes") }}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("notes") }}</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mt-2 text-no-wrap">
                    <div class="text-subtitle-2">
                      <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Ut lacus sem, maximus vitae interdum in, -->
                      {{ (feedLatestData && feedLatestData.note != '') ? feedLatestData.note : $t('notSpecified') }}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            <!-- </v-list> -->
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <!-------------------------- Tablet Screens -------------------------->
    <!-- start -->
    <v-card
      v-if="$vuetify.breakpoint.width <= 980"
      elevation="0"
      class="px-5 mt-5"
      :loading="loading"
      :class="loading ? '' : 'py-1'"
    >
      <!-- <div v-if="$vuetify.breakpoint.width <= 980"> -->
      <div class="d-flex mt-5">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          outlined
          :placeholder="$t('animal.searchByFeedName')"
          dense
          v-model="search"
          @input="resetSearchOnEmpty"
          class="shrink"
        ></v-text-field>
        <v-btn
          :disabled="search.length < 1"
          color="primary"
          height="40"
          width="40"
          max-width="40"
          outlined
          class="ml-8"
          @click="searchFeedInfo"
        >
          <v-icon>mdi-filter-outline</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <div class="py-1 title">
          {{ from }} - {{ to }} {{$t('of')}} {{ totalFeedInfo }}
        </div>
        <v-btn
          class="mx-2"
          fab
          small
          outlined
          color="primary"
          :disabled="tabletTableOptions.page <= 1"
          @click="tabletPageChange(false)"
        >
          <v-icon dark> mdi-chevron-left </v-icon>
        </v-btn>
        <v-btn
          class="mx-2"
          fab
          small
          outlined
          color="primary"
          :disabled="tabletTableOptions.page >= totalPages"
          @click="tabletPageChange(true)"
        >
          <v-icon dark> mdi-chevron-right </v-icon>
        </v-btn>
      </div>
      <v-card
        v-for="(item, index) in tableFeedInfoItems"
        :key="index"
        class="inner-card my-4 py-2 px-4"
        :elevation="0"
        :style="
          index % 2 !== 0 && {
            backgroundColor: 'rgba(243, 243, 243, 0.5)',
          }
        "
      >
        <v-row class="py-2" no-gutters>
          <v-col md="6">{{$t('animal.feedsName')}}</v-col>
          <v-col md="6">{{ item.feedName }}</v-col>
        </v-row>
        <v-row class="py-2" no-gutters>
          <v-col md="6">{{$t('animal.feedQuantity')}}</v-col>
          <v-col md="6">{{ item.feedQuantity }}</v-col>
        </v-row>
        <v-row class="py-2" no-gutters>
          <v-col md="6">{{ $t("date") }}</v-col>
          <v-col md="6">{{ item.date }}</v-col>
        </v-row>
        <v-row class="py-2" no-gutters>
          <v-col md="6">{{ $t("note") }}</v-col>
          <v-col md="6"> {{ item.note }}</v-col>
        </v-row>
      </v-card>
    </v-card>
    <!------------------------ End -------------------------->
    <v-card v-else elevation="0" class="px-5 mt-5">
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="tableFeedInfoItems"
          :items-per-page="itemsPerPage"
          :loading="loading"
          :loading-text="$t('animal.loadingFeedInfo')"
          :options.sync="tableOptions"
          hide-default-footer
          :header-props="{
                'sort-icon': 'mdi-unfold-more-horizontal'
              }"
        >
          <template v-slot:top>
            <div class="d-flex mt-5">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                outlined
                :placeholder="$t('animal.searchByFeedName')"
                dense
                v-model="search"
                @input="resetSearchOnEmpty"
                class="shrink"
              >
              </v-text-field>
              <v-btn
                :disabled="search.length < 1"
                color="primary"
                height="40"
                width="40"
                max-width="40"
                outlined
                class="ml-8"
                @click="searchFeedInfo"
              >
                <v-icon>mdi-filter-outline</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <div class="py-1 title">
                {{ from }} - {{ to }} {{$t('of')}} {{ totalFeedInfo }}
              </div>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="tableOptions.page <= 1"
                @click="pageChange(false)"
              >
                <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="tableOptions.page >= totalPages"
                @click="pageChange(true)"
              >
                <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>
             <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                left
                :min-width="417"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark> mdi-cog-outline </v-icon>
                  </v-btn>
                </template>

                <v-card width="417">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          $t("customization")
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <div class="pl-3 pt-2 font-weight-normal">
                      {{ $t("recordsPerPage") }}
                    </div>
                    <v-list-item>
                      <v-list-item-content>
                        <v-slider
                          v-model="itemsPerPageSlider"
                          :tick-labels="itemsPerPageOptions"
                          :max="3"
                          step="1"
                          ticks="always"
                          tick-size="4"
                        ></v-slider>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-n3"></v-divider>
                  </v-list>
                  <v-card-text>
                    <v-container fluid>
                      <v-row>
                        <v-col
                          class="mt-n9"
                          cols="6"
                          v-for="header in tableFeedInfoHeaders"
                          :key="header.value"
                        >
                          <v-checkbox
                            v-model="selectedHeaders"
                            :label="header.text"
                            color="primary"
                            :value="header.text"
                            hide-details
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-layout justify-center>
                    <v-card-actions class="mb-5">
                      <v-spacer></v-spacer>

                      <v-btn
                        outlined
                        color="primary"
                        @click="menu = false"
                        width="190"
                      >
                        {{ $t("restoreDefault") }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        width="190"
                        @click="resetTableStructure"
                      >
                        {{ $t("apply") }}
                      </v-btn>
                    </v-card-actions>
                  </v-layout>
                </v-card>
             </v-menu>
            </div>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="primary"
              :height="8"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data v-if="tableFeedInfoItems.length < 1">
            {{$t('animal.nOFEEDINFOAVAILABLE')}}
          </template>
          <template v-slot:[`item.feedName`]="{ item }">
            <p class="mt-2">
              {{ item.feedName }}
            </p>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            <p class="mt-2">
              {{ item.date | formatDate }}
            </p>
          </template>
          <template v-slot:[`item.note`]="{ item }">
            <!-- <p class="mt-2"></p> -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <!-- {{ item.note }} -->
                  <v-btn
                    text
                    color="primary"
                    @click="addNote(item.notes)"
                  >
                    {{$t('view')}}
                  </v-btn>

                </span>
              </template>
              <span
                >{{$t('note')}}</span
              >
            </v-tooltip>
          </template>

          <!-- <template v-if="tableFeedInfoItems.length > 0" v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="(item, index) in items"
                :key="index"
                style="position: relative; width: 0; height: 0"
                @click="rowClicked(item.animalNumber)"
              >
                <td>
                  <v-checkbox
                    multiple
                    v-model="selected"
                    :value="item"
                    style="margin:0px;padding:0px"
                    hide-details
                    v-on:click.stop=""
                  />
                </td>
                <template v-for="h in tableFeedInfoHeaders">
                  <td :key="h.value" class="text-truncate">
                    {{ item[h.value] }}
                  </td>
                </template>
              </tr>
            </tbody>
          </template> -->
        </v-data-table>
      </v-card-text>
      <v-dialog
      v-model="showNote"
      width="600px"
    >
      <v-card>
          <v-toolbar flat class="white--text" color="secondary">
                <v-toolbar-title>
                  {{$t("note")}}
                </v-toolbar-title>
            </v-toolbar>
        <v-card-text class="py-5">
          <p>{{ notes || 'No note available.' }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showNote = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-card>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
export default {
  components: {},
  updated() {
    // console.log(this.tableFeedInfoItems, "tableFeedInfoItems");
  },
  async mounted() {
    this.tableHeaders = this.tableFeedInfoHeaders;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  watch: {
    tableOptions: {
      handler() {
        this.getFeedInfoData();
      },
      deep: true,
    },
  },
  created() {
    if (this.checkBreakPoints) this.getTabletFeedInfoData();
  },
  data() {
    return {
      animal: {},
      from: 0,
      to: 0,
      showNote:false,
      notes:[],
      totalPages: 1,
      pageCount: 0,
      tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
      tab: null,
      search: "",
      itemsPerPage: 10,
      loading: false,
      tableOptions: {},
      totalFeedInfo: 0,
      tableFeedInfoHeaders: [
        {
          text: this.$t('animal.feedsName'),
          value: "feedName",
          align: "start",
          width: "180px",
        },
        {
          text: this.$t('animal.fEEDQUANTITY'),
          value: "feedQuantity",
          align: "start",
          width: "90px",
        },
        { text: this.$t("date"), value: "date", align: "start", width: "90px" },
        { text: this.$t("notes"), value: "note", align: "start", width: "90px", sortable: false},
      ],
      tableFeedInfoItems: [
        // {
        //   feedName:
        //     "Green fodder, hay, legumes, non-legumes, silage, TMR, concentrates, etc.",
        //   feedQuantity: "2 Times",
        //   date: "10/12/2020",
        //   note: "View",
        // },
      ],
      feedLatestData: {},

      menu: false,
      itemsPerPageSlider: 1,
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedHeaders: [],
      tableHeaders: [],
      oldSelected: [],
      allSelectedHeaders: [
        this.$t('animal.feedsName'),
        this.$t('animal.fEEDQUANTITY'),
        this.$t("date"),
        this.$t("notes"),
      ],
      noRecordHeader: [
        this.$t('animal.feedsName'),
        this.$t('animal.fEEDQUANTITY'),
        this.$t("date"),
        this.$t("notes"),
      ],
    };
  },
  computed: {
    animalNumber: function () {
      return this.$route.params.animal_number;
    },
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  methods: {
    getFeedInfoData() {
      this.loading = true;
      AnimalService.getFeedRecords(
        this.tableOptions,
        this.animalNumber,
        this.search
      )
        .then((res) => {
          this.feedLatestData = res.data.animalFeed.latest;
          let feedData = res.data.animalFeed.rows;
          feedData = this.mapFeedData(feedData);
          this.tableFeedInfoItems = feedData;
          this.totalFeedInfo = res.data.animalFeed.total_rows;

          if (this.totalFeedInfo < 1) {
            this.oldSelected = this.selectedHeaders;
            this.selectedHeaders = this.noRecordHeader;
          } else {
            if (this.oldSelected.length > 1)
              this.selectedHeaders = this.oldSelected;
            else {
              this.selectedHeaders = this.allSelectedHeaders;
              this.oldSelected = [];
            }
          }
          
          this.resetTableStructure();

          // this.pageCount = Math.ceil(
          //   this.totalAnimals / this.tableOptions.itemsPerPage
          // );
          this.totalPages = Math.ceil(
            this.totalFeedInfo / this.tableOptions.itemsPerPage
          );
          this.from =
            (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
          this.to =
            this.tableOptions.page * this.tableOptions.itemsPerPage -
            (this.tableOptions.itemsPerPage - res.data.animalFeed.num_rows);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getTabletFeedInfoData() {
      this.loading = true;
      AnimalService.getFeedRecords(
        this.tabletTableOptions,
        this.animalNumber,
        this.search
      )
        .then((res) => {
          this.feedLatestData = res.data.animalFeed.latest;
          let feedData = res.data.animalFeed.rows;
          feedData = this.mapFeedData(feedData);
          this.tableFeedInfoItems = feedData;
          this.totalFeedInfo = res.data.animalFeed.total_rows;
          // this.pageCount = Math.ceil(
          //   this.totalAnimals / this.tabletTableOptions.itemsPerPage
          // );
          this.totalPages = Math.ceil(
            this.totalFeedInfo / this.tabletTableOptions.itemsPerPage
          );
          this.from =
            (this.tabletTableOptions.page - 1) *
              this.tabletTableOptions.itemsPerPage +
            1;
          this.to =
            this.tabletTableOptions.page *
              this.tabletTableOptions.itemsPerPage -
            (this.tabletTableOptions.itemsPerPage -
              res.data.animalFeed.num_rows);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    resetSearchOnEmpty() {
      // if (this.search === "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletFeedInfoData();
      } else {
        this.tableOptions.page = 1;
        this.getFeedInfoData();
      }
    },
    searchFeedInfo() {
      // if (this.search === "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletFeedInfoData();
      } else {
        this.tableOptions.page = 1;
        this.getFeedInfoData();
      }
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getFeedInfoData();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.getTabletFeedInfoData();
    },
    mapFeedData(feedData) {
      return feedData.map((item) => {
        return {
          feedName: item.feedName,
          feedQuantity: item.feedQty + ' ' + item.feedUom,
          date: item.createdAt,
          note: item.noteQty,
          notes: item.note,
        };
      });
    },
    resetTableStructure() {
      // this.startLoading();
      this.loading = true;
      this.tableHeaders = this.tableFeedInfoHeaders.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      // this.stopLoading();
      this.loading = false;
    },
    addNote(item){
      this.notes = item;
      this.showNote = true;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
.v-list-item__title,
.v-list-item__subtitle {
  white-space: normal;
}

::v-deep .v-data-table__wrapper table tbody tr:nth-of-type(odd) {
 background-color: rgba(0, 0, 0, 0.035) !important;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}

.text-no-wrap {
  white-space: nowrap;
}

::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

</style>
